import { sellers } from '@/mocks/sellers';

export default function SellerCards() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-3 whitespace-nowrap">Verified</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Trusted <span className="text-accent-500">Spreadsheet Sellers</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
            Hand-picked sellers from the VigorBuy Spreadsheet with high ratings and verified QC
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {sellers.map((seller) => (
            <div
              key={seller.name}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 hover:border-accent-200 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-base font-semibold text-foreground-900">{seller.name}</h3>
                    {seller.badge === 'Verified' && (
                      <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-verified-badge-fill text-sm"></i>
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{seller.category}</span>
                </div>
                <span className={`px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                  seller.badge === 'Verified' ? 'bg-accent-100 text-accent-700' :
                  seller.badge === 'Top Rated' ? 'bg-primary-100 text-primary-700' :
                  seller.badge === 'Premium' ? 'bg-foreground-100 text-foreground-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>
                  {seller.badge}
                </span>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <p className="font-heading text-xl font-bold text-foreground-900">{seller.score}</p>
                  <p className="text-xs text-foreground-400">Score</p>
                </div>
                <div className="text-center">
                  <p className="font-heading text-xl font-bold text-foreground-900">{seller.qcRating}</p>
                  <p className="text-xs text-foreground-400">QC Rating</p>
                </div>
                <div className="text-center">
                  <p className="font-heading text-xl font-bold text-foreground-900">{(seller.orders / 1000).toFixed(1)}k</p>
                  <p className="text-xs text-foreground-400">Orders</p>
                </div>
              </div>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="mt-4 w-full block text-center px-4 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                View Seller <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}